import { inject, Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({ providedIn: 'root' })
export class IconsService {
  /**
   * Constructor
   */
  constructor() {
    const domSanitizer = inject(DomSanitizer);
    const matIconRegistry = inject(MatIconRegistry);

    // Register icon sets. Every one is namespaced, which is what every `svgIcon` in
    // this app asks for.
    //
    // R9. There used to be a namespace-less set here — `material-twotone.svg`, 909 KB,
    // the largest asset in `public/`. A set with no namespace answers only bare lookups
    // like `svgIcon="edit"`, and there is not one of those: all 517 usages carry a
    // namespace, the handful of bare `icon:` strings in code are Material *font* names
    // or belonged to a dead `getActions`, since removed. Measured on a real page load,
    // the browser fetched `heroicons-outline`, `heroicons-solid`, `heroicons-mini` and
    // `material-outline` — and never the twotone set, because nothing could ask for it.
    // It still shipped in `dist/`, which is committed and deployed.
    matIconRegistry.addSvgIconSetInNamespace(
      'mat_outline',
      domSanitizer.bypassSecurityTrustResourceUrl('icons/material-outline.svg')
    );
    matIconRegistry.addSvgIconSetInNamespace(
      'mat_solid',
      domSanitizer.bypassSecurityTrustResourceUrl('icons/material-solid.svg')
    );
    matIconRegistry.addSvgIconSetInNamespace(
      'feather',
      domSanitizer.bypassSecurityTrustResourceUrl('icons/feather.svg')
    );
    matIconRegistry.addSvgIconSetInNamespace(
      'heroicons_outline',
      domSanitizer.bypassSecurityTrustResourceUrl('icons/heroicons-outline.svg')
    );
    matIconRegistry.addSvgIconSetInNamespace(
      'heroicons_solid',
      domSanitizer.bypassSecurityTrustResourceUrl('icons/heroicons-solid.svg')
    );
    matIconRegistry.addSvgIconSetInNamespace(
      'heroicons_mini',
      domSanitizer.bypassSecurityTrustResourceUrl('icons/heroicons-mini.svg')
    );
  }
}
